import type { Spell } from '@/types';

/**
 * Catálogo completo de hechizos. Se aprenden por skill tree (la mayoría)
 * o por evento narrativo específico.
 */
export const HECHIZOS: readonly Spell[] = [
  {
    id: 'susurro_rio',
    nombre: 'Susurro del Río',
    descripcion:
      'Calmás a un enemigo o NPC hostil con una frase corta y un aliento lento. En combate, reduce el daño enemigo a la mitad por un turno.',
    costoMana: 5,
    contexto: ['combate', 'dialogo'],
    requiereSkill: 'palabra_calmante',
  },
  {
    id: 'vinculo_sanador',
    nombre: 'Vínculo Sanador',
    descripcion: 'Apoyás las dos manos sobre el suelo y algo vivo te devuelve fuerzas.',
    costoMana: 8,
    contexto: ['combate', 'exploracion'],
    requiereSkill: 'curar_con_tacto',
  },
  {
    id: 'llamado_guardian',
    nombre: 'Llamado del Guardián',
    descripcion: 'Invocás a un capibara ancestral que pelea por vos durante un turno.',
    costoMana: 12,
    contexto: ['combate'],
    requiereSkill: 'invocacion_susurrada',
  },
  {
    id: 'velo_niebla',
    nombre: 'Velo de Niebla',
    descripcion: 'El aire se espesa alrededor tuyo. Escape asegurado del combate actual.',
    costoMana: 10,
    contexto: ['combate'],
    desbloqueadoPorEvento: 'niebla_acantilados',
  },
  {
    id: 'vinculo_empatico',
    nombre: 'Vínculo Empático',
    descripcion:
      'Al tocar a alguien, ves un pedazo de su pasado. Puede abrir diálogos imposibles.',
    costoMana: 6,
    contexto: ['dialogo', 'exploracion'],
    desbloqueadoPorEvento: 'primer_vinculo_pipo',
  },
  {
    id: 'ojo_del_bosque',
    nombre: 'Ojo del Bosque',
    descripcion: 'El bosque te muestra lo que hay más allá de la próxima curva.',
    costoMana: 4,
    contexto: ['exploracion'],
    desbloqueadoPorEvento: 'primera_visita_santuario',
  },
  {
    id: 'canto_nayade',
    nombre: 'Canto de Náyade',
    descripcion: 'La líder del Clan del Río te presta su voz. Persuasión casi total en diálogo.',
    costoMana: 14,
    contexto: ['dialogo'],
    desbloqueadoPorEvento: 'bendicion_nayade',
  },
  {
    id: 'brasa_interior',
    nombre: 'Brasa Interior',
    descripcion: 'Un fuego contenido. Golpe extra devastador; cuesta caro.',
    costoMana: 15,
    contexto: ['combate'],
    desbloqueadoPorEvento: 'juramento_guardianes_fuego',
  },
  {
    id: 'paso_entre_raices',
    nombre: 'Paso entre Raíces',
    descripcion: 'Te desplazás entre dos árboles sin cruzar el espacio entre ellos.',
    costoMana: 9,
    contexto: ['exploracion', 'combate'],
    desbloqueadoPorEvento: 'enseñanza_susurradores',
  },
  {
    id: 'lamento_sombra',
    nombre: 'Lamento de la Sombra',
    descripcion:
      'Un hechizo oscuro. Consume reputación con todas las facciones buenas, pero inflige daño masivo.',
    costoMana: 18,
    contexto: ['combate'],
    desbloqueadoPorEvento: 'pacto_sombra',
  },
];

const MAPA = new Map<string, Spell>(HECHIZOS.map((h) => [h.id, h]));

export function obtenerHechizo(id: string): Spell | undefined {
  return MAPA.get(id);
}
